import React from 'react';
// import { connect } from 'react-redux'
import { SvgArrowIcon, SvgCheckIcon } from '../svg';

// Used by AddPercentage & VIDTModule

class VIDTermination extends React.Component {

    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() {
        let { contractId, addToContract, type, customerId } = this.props;

        // Preferrably use contractId if available (for distinction)
        let moduleId = contractId ? contractId : customerId
        this.setState({ id: moduleId })

        addToContract(type + "formerFund", "000", moduleId)
        addToContract(type + "formerFundName", "", moduleId)
        addToContract(type + "fundTransfer", false, moduleId)
        addToContract(type + "fundTermination", false, moduleId)
    }


    render() {
        let { type, fundTable, values, onChange, onCheckboxChange, enableTransferCancellation } = this.props;
        let { id } = this.state;
        let formerFund = values[type + "formerFund"]
        let fundTransfer = values[type + "fundTransfer"]
        let fundTermination = values[type + "fundTermination"]
        let fundTransferCancellation = values[type + "fundTransferCancellation"]

        let filter = (f) => f.IsMutualInsurance === "0" || f.Name === "Ótilgreint"

        return (
            <div className="card">
                    <div className="group-type collapsed card-header" data-toggle="collapse" data-target={"#termination-section-" + type + "-" + id} aria-expanded="false" aria-controls={"termination-section-" + type + "-" + id}>
                        <button className="toggle-button">
                            {formerFund && formerFund !== '000' && (fundTransfer || fundTermination || fundTransferCancellation) ? (<span className="check"><span className="check check-icon big green">
                                <SvgCheckIcon />
                            </span></span>) : (<span></span>)}
                            {this.props.heading}
                            <span className="arrow-toggle-button">
                                <SvgArrowIcon />
                            </span>
                        </button>
                    </div>
                    <div className="collapse" id={"termination-section-" + type + "-" + id}>
                        <div className="card card-body">
                            <div className="form-row align-items-center">
                                <div className="col-sm-8">
                                    <label htmlFor={`${type}-former-fund-${id}`} className="col-form-label">Fyrri vörsluaðili</label>
                                </div>
                                <div className="col-sm-4 text-right">
                                    <select className="custom-select col-12 col-sm-6" id={`vid-former-fund-${id}`} name={type + "formerFund"} onChange={(e) => onChange(e, "termination", id)} >
                                        {fundTable.data && !fundTable.isFetching && fundTable.data.FundTable.FundLine.filter(filter).map((fund) =>
                                            <option key={`${type}-${fund.FundId || fund.Name}`} value={fund.FundId}>{fund.Name}</option>
                                        )}
                                    </select>
                                </div>
                            </div>
                            <div className={`form-row align-items-center checkbox ${values[type + "fundTransferCancellation"] ? 'disabled' : ''}`}>
                                <label htmlFor={`${type}-former-fund-termination-${id}`} className="col-form-label col-10 col-sm-8">Uppsögn á vörsluaðila</label>
                                <input type="checkbox" id={`${type}-former-fund-termination-${id}`} checked={values[type + "fundTermination"]} disabled={values[type + "fundTransferCancellation"]} onChange={(e) => onCheckboxChange(e, "termination", id)} name={type + "fundTermination"}></input>
                                <span className="checkmark"></span>
                            </div>
                            <div className={`form-row align-items-center checkbox`}>
                                <label htmlFor={`${type}-former-fund-transfer-${id}`} className="col-form-label col-10 col-sm-8">Óska eftir flutningi á inneign frá vörsluaðila</label>
                                <input type="checkbox" id={`${type}-former-fund-transfer-${id}`} checked={values[type + "fundTransfer"]} onChange={(e) => onCheckboxChange(e, "termination", id)} name={type + "fundTransfer"}></input>
                                <span className="checkmark"></span>
                            </div>
                            {enableTransferCancellation &&
                            <div className={`form-row align-items-center checkbox ${values[type + "fundTermination"] ? 'disabled' : ''}`}>
                                <label htmlFor={`${type}-former-fund-transfer-cancellation-${id}`} className="col-form-label col-10 col-sm-8">Afturköllun á uppsögn frá vörsluaðila</label>
                                <input type="checkbox" id={`${type}-former-fund-transfer-cancellation-${id}`} checked={values[type + "fundTransferCancellation"]} disabled={values[type + "fundTermination"]} onChange={(e) => onCheckboxChange(e, "termination", id)} name={type + "fundTransferCancellation"}></input>
                                <span className="checkmark"></span>
                            </div>
                            }
                        </div>
                    </div>
            </div>
        )
    }
}

VIDTermination.defaultProps = {
    heading: "Bæta við uppsögn og/eða flutningsbeiðni",
    type: "VID",
    enableTransferCancellation: false
}

export default VIDTermination;